var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPicture(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#F6C944"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_131_413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0266 20.0284C21.0266 20.8195 20.7123 21.5783 20.1529 22.1377C19.5935 22.6971 18.8348 23.0114 18.0437 23.0114C17.2525 23.0114 16.4938 22.6971 15.9344 22.1377C15.375 21.5783 15.0607 20.8195 15.0607 20.0284C15.0607 19.2373 15.375 18.4786 15.9344 17.9191C16.4938 17.3597 17.2525 17.0455 18.0437 17.0455C18.8348 17.0455 19.5935 17.3597 20.1529 17.9191C20.7123 18.4786 21.0266 19.2373 21.0266 20.0284Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0739 13.0682C11.2827 13.0682 10.524 13.3825 9.9646 13.9419C9.40519 14.5013 9.09091 15.26 9.09091 16.0511V33.9489C9.09091 34.74 9.40519 35.4987 9.9646 36.0581C10.524 36.6175 11.2827 36.9318 12.0739 36.9318H37.9261C38.7173 36.9318 39.476 36.6175 40.0354 36.0581C40.5948 35.4987 40.9091 34.74 40.9091 33.9489V16.0511C40.9091 15.26 40.5948 14.5013 40.0354 13.9419C39.476 13.3825 38.7173 13.0682 37.9261 13.0682H12.0739ZM37.9261 15.0568C38.1898 15.0568 38.4428 15.1616 38.6292 15.348C38.8157 15.5345 38.9205 15.7874 38.9205 16.0511V27.983L31.4134 24.1111C31.2269 24.0177 31.0157 23.9853 30.8098 24.0184C30.6039 24.0516 30.4136 24.1487 30.2659 24.296L22.8881 31.6739L17.5983 28.15C17.4073 28.0228 17.1782 27.9657 16.9499 27.9881C16.7215 28.0106 16.508 28.1114 16.3455 28.2733L11.0835 32.9545V34.0284C11.0811 34.002 11.0798 33.9754 11.0795 33.9489V16.0511C11.0795 15.7874 11.1843 15.5345 11.3708 15.348C11.5572 15.1616 11.8102 15.0568 12.0739 15.0568H37.9261Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_131_413"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.8182,
    height: 31.8182,
    fill: "white",
    transform: "translate(9.09091 9.09091)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicture);
export default __webpack_public_path__ + "static/media/picture.e5a9f8a23d74186efc3d62cb7cc7ffeb.svg";
export { ForwardRef as ReactComponent };